import React from "react";
import { Box, Typography, MenuItem } from "@mui/material";
import { toCurrency } from "@helpers";
import { SecurityImage } from "@components/SecurityImage";

export interface Props {
  name: string;
  isin?: string;
  typeName: string;
  stockExchangeName: string;
  shouldShowQuote?: boolean;
  quote?: number;
  currency?: string;
  handleClick: () => void;
  testid?: string;
  image?: string | null;
}

export const Symbol = ({
  name,
  isin,
  typeName,
  stockExchangeName,
  shouldShowQuote = true,
  quote,
  currency,
  handleClick,
  testid,
  image,
}: Props) => {
  return (
    <MenuItem
      onClick={() => handleClick()}
      data-testid={testid ? testid : "symbol"}
    >
      <Box width="100%" display="flex" alignItems="flex-start" gap={3}>
        <SecurityImage
          src={image}
          alt={name}
          width={shouldShowQuote ? 40 : 20}
          height={shouldShowQuote ? 40 : 20}
        />
        <Box>
          <Box display="flex" alignItems="baseline" gap={1}>
            <Typography variant="body4" color="textPrimary" noWrap>
              {name.toUpperCase()}
            </Typography>
            <Typography variant="caption" color="textSecondary">
              {isin}
            </Typography>
          </Box>
          {shouldShowQuote && (
            <Typography variant="caption" color="textSecondary">
              <b>{typeName}</b> - {stockExchangeName}
              {quote ? ` ${toCurrency(quote, currency || "EUR")}` : ""}
            </Typography>
          )}
        </Box>
      </Box>
    </MenuItem>
  );
};
